import { FC, PropsWithChildren, useRef, useState } from 'react';
import { WYSIWYGContext, WYSIWYGContextState } from './WYSIWYGContext';

export type WYSIWYGProviderProps = {
  isFullHtmlDoc: boolean;
  canLoadHTML: boolean;
  initialValue: string;
  value: string;
  lastSavedValue: string;
  onChange: (content: string) => void;
};

export const WYSIWYGProvider: FC<PropsWithChildren<WYSIWYGProviderProps>> = ({
  children,
  initialValue,
  value: contentValue,
  lastSavedValue,
  onChange,
  isFullHtmlDoc,
  canLoadHTML,
}) => {
  /** handles whether tinyMCE is visible or not */
  const [renderTiny, setRenderTiny] = useState<boolean>(true); // used to reinitialize tiny

  /** html refs */
  const htmlEditorRef = useRef<Record<string, any>>(null);
  const loadHtmlFileInputRef = useRef<HTMLInputElement>(null);

  /** handles image state */
  const [selectedImage, setSelectedImage] = useState<HTMLImageElement>();
  const [selectedImageAnchor, setSelectedImageAnchor] = useState<HTMLAnchorElement>();

  /** handles value state */
  const [initValue, setInitValue] = useState<string>(initialValue || contentValue || ''); // should be a non-changing value

  const value: WYSIWYGContextState = {
    canLoadHTML,
    contentValue,
    htmlEditorRef,
    initValue,
    isFullHtmlDoc,
    lastSavedValue,
    loadHtmlFileInputRef,
    onChange,
    renderTiny,
    selectedImage,
    selectedImageAnchor,
    setInitValue,
    setRenderTiny,
    setSelectedImage,
    setSelectedImageAnchor,
  };

  return <WYSIWYGContext.Provider value={value}>{children}</WYSIWYGContext.Provider>;
};
